<template>
  <div class="drawer-detail">
    <!-- <div class="field-type">
      <pre class="value company-pre">{{ company['人员整体情况'] }}</pre>
    </div> -->
    <div class="field-type" style="border:none;padding-bottom:0px;">
      <span class="label">最在意的前五个条件:</span>
      <TagShow v-if="Array.isArray(company.tagsort)&&company.tagsort.length>0" :tags="company.tagsort"></TagShow>
      <div v-else class="gray-text value company-pre" style="background: #2478b526;">
        <p>暂无数据</p>
      </div>
    </div>
    <div class="field-type" style="border:none;padding-bottom:0px;">
      <div class="field-type-tag">
        <span class="label">倾向学历:</span>
        <div class="flex-row flex-wrap full-width">
          <template v-if="company.用人偏好 && company.用人偏好.学历 && company.用人偏好.学历.length > 0">
            <span
              v-for="item in company.用人偏好.学历"
              :key="item"
              style="margin: 0px 10px 5px 0;line-height: 22px;color:#000"
              >{{ item }}</span
            >
          </template>
          <span v-else style="margin: 0px 10px 5px 0;line-height: 22px;color:#000">{{ '--' }}</span>
        </div>
      </div>
      <pre v-if="company['倾向学历备注']" class="value company-pre">{{ company['倾向学历备注'] }}</pre>
    </div>
    <div class="field-type" style="border:none;padding-bottom:0px;">
      <div class="field-type-tag">
        <span class="label">倾向年龄:</span>
        <div class="flex-row flex-wrap full-width">
          <span style="margin: 0px 10px 5px 0;line-height: 22px;color:#000">{{ company.倾向年龄 || '--' }}</span>
        </div>
      </div>
      <pre v-if="company['倾向年龄备注']" class="value company-pre">{{ company['倾向年龄备注'] }}</pre>
    </div>
    <div class="field-type" style="border:none;padding-bottom:0px;">
      <div class="field-type-tag">
        <span class="label">倾向性别:</span>
        <div class="flex-row flex-wrap full-width">
          <span style="margin: 0px 10px 5px 0;line-height: 22px;color:#000">{{ company.倾向性别 || '--' }}</span>
        </div>
      </div>
      <pre v-if="company['倾向性别备注']" class="value company-pre">{{ company['倾向性别备注'] }}</pre>
    </div>
    <div class="field-type" style="border:none;padding-bottom:0px;">
      <div class="field-type-tag">
        <span class="label">倾向平台:</span>
        <div class="flex-row flex-wrap full-width">
          <template v-if="company.用人偏好 && company.用人偏好.平台 && company.用人偏好.平台.length > 0">
            <span
              v-for="item in company.用人偏好.平台"
              :key="item"
              style="margin: 0px 10px 5px 0;line-height: 22px;color:#000"
              >{{ item }}</span
            >
          </template>
          <span v-else style="margin: 0px 10px 5px 0;line-height: 22px;color:#000">{{ '--' }}</span>
        </div>
      </div>
      <pre v-if="company['倾向平台备注']" class="value company-pre">{{ company['倾向平台备注'] }}</pre>
    </div>
    <div
      v-for="field in ['目标公司', '不倾向公司', '勿推荐公司']"
      :key="field"
      class="field-type field-type-tag"
      style="border:none;margin-bottom:0;padding-bottom:0px;"
    >
      <span class="label">{{ field }}:</span>
      <div class="flex-row flex-wrap full-width">
        <template v-if="company[field] && company[field].length > 0">
          <span
            v-for="item in company[field]"
            :key="item"
            :style="`margin: 0px 10px 5px 0;line-height: 22px;color:${companyTagMap[field]}`"
            @click="openCompany(item)"
            >{{ item }}</span
          >
        </template>
        <span v-else :style="`margin: 0px 10px 5px 0;line-height: 22px;color:${companyTagMap[field]}`">{{ '--' }}</span>
      </div>
    </div>
    <div class="field-type" style="border:none">
      <span class="label">典型人才:</span>
      <div class="flex-row flex-wrap full-width">
        <span
          v-for="item in company['典型人才']"
          :key="item._id"
          :style="`margin: 0px 10px 5px 0;line-height: 22px;cursor:pointer;color:#409EFF`"
          @click="openRadish(item)"
          >{{ item.姓名 }}</span
        >
      </div>
    </div>
    <!-- <div v-for="field in fields" :key="field" class="field-type">
      <span class="label">{{translateTag[field]||field}}:</span>
      <pre class="value company-pre">{{company[field]}}</pre>
    </div> -->
  </div>
</template>
<script>
import TagShow from './TagShow'

export default {
  components: { TagShow },
  props: {
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      fields: [
        '人员整体情况',
        'tagsort',
        '用人偏好',
        '倾向学历备注',
        '倾向年龄',
        '倾向年龄备注',
        '倾向性别',
        '倾向性别备注',
        '倾向平台备注',
        '目标公司',
        '不倾向公司',
        '勿推荐公司',
        '典型人才',
      ],
      companyTagMap:{
        '目标公司':'#409EFF',
        '不倾向公司':'#E6A23C',
        '勿推荐公司':'#F56C6C',
      },
    }
  },
  methods: {
    openCompany(name){
      this.$emit('openCompany',name)
    },
    openRadish(item){
      window.open(`${window.frontend}/#/radish-detail-blank/${item._id}`, '_blank')
    },
  },
}
</script>
<style scoped>
.flex {
  display: flex;
}
.value {
  background-color: #f2f2f2;
  padding: 10px;
}
</style>
<style src="../../constant/css/detail.css" scoped></style>
